import { render, staticRenderFns } from "./HotelMealplanList.vue?vue&type=template&id=edea1bc8&"
import script from "./HotelMealplanList.vue?vue&type=script&lang=js&"
export * from "./HotelMealplanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports